(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.NutrientManagementToolsController = (function(superClass) {
    extend(NutrientManagementToolsController, superClass);

    function NutrientManagementToolsController(scope, transitions, modal, http, service) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.practiceIsSelected = bind(this.practiceIsSelected, this);
      this.togglePractice = bind(this.togglePractice, this);
      this.service.getManagementTechniquesDefaults();
      NutrientManagementToolsController.__super__.constructor.apply(this, arguments);
    }

    NutrientManagementToolsController.prototype.togglePractice = function(practice, key) {
      if (this.practiceIsSelected(practice, key)) {
        _.remove(this.service.fpcResult.data[key], (function(_this) {
          return function(item) {
            return item === practice;
          };
        })(this));
        return this.showConservationAlert = false;
      }
      return this.service.fpcResult.data[key].push(practice);
    };

    NutrientManagementToolsController.prototype.practiceIsSelected = function(practice, key) {
      return _.find(this.service.fpcResult.data[key], (function(_this) {
        return function(item) {
          return item === practice;
        };
      })(this));
    };

    return NutrientManagementToolsController;

  })(Controller);

}).call(this);
